import type { ValidatorMessage } from 'helpers/validators';
import type { TFunction, TOptions } from 'i18next';
import { isValidElement } from 'react';

export function getErrorTranslation(t: TFunction, value: ValidatorMessage) {
  if (typeof value === 'string') {
    return t(value);
  }

  if (typeof value === 'object' && !Array.isArray(value)) {
    return value;
  }

  if (isValidElement(value)) {
    return value;
  }

  const [key, options] = value as [string, TOptions];

  return t(key, options);
}

export function replaceErrorField(
  errors: { field: string; message: any }[],
  replace: { [field: string]: string }
) {
  return errors.map((error) => {
    const e = Object.keys(replace).find((k) => k === error.field);

    if (e == null) return error;

    return {
      ...error,
      field: replace[e],
    };
  });
}
